module.exports = __webpack_public_path__ + "img/smart-tv.7a12515b.png";